import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import Ic from "../common/Ic";
import { navTabs, navTabMap, TAB_FEATURE } from "../../constants/navConfig";

export default function BottomBar() {
  const { t, h, page, go, role, plan, setShareModalOpen } = useContext(Ctx);
  if (role === "admin") return null;

  const planFeatures = (role === "landlord" && plan?.features) ? plan.features : null;

  // Tabs + sub-page→tab map now live in src/constants/navConfig.js so the
  // desktop Sidebar renders the exact same navigation (no drift).
  const tabs = navTabs(role, t);
  const tabMap = navTabMap(role);
  const activeTab = tabMap[page] || page;

  // Render one tab button.
  const renderTab = ([id, ic, l]) => {
    const isActive = activeTab === id;
    const requiredFeature = TAB_FEATURE[id];
    const isLocked = planFeatures && requiredFeature && !planFeatures.includes(requiredFeature);
    // Coach-mark anchor: semantic short name (e.g. chatList to 'chat')
    // so coach-mark step definitions stay readable.
    const coachId = ({
      chatList: 'chat', tenChat: 'chat',
      spJobs: 'jobs', spHistory: 'history', spEarnings: 'earnings',
    })[id] || id.toLowerCase();
    return <button key={id} data-coach={`nav-${coachId}`} onClick={() => go(id)} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, padding: "7px 2px", position: "relative", flex: 1, minWidth: 0, WebkitTapHighlightColor: "transparent" }}>
      <div style={{ width: 34, height: 30, borderRadius: 12, background: isActive ? `${h.ac}14` : "transparent", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.24s cubic-bezier(0.32,0.72,0.22,1)", opacity: isLocked ? 0.45 : 1 }}>
        <Ic n={ic} s={19} c={isActive ? h.ac : (h.tt || h.sc)} />
      </div>
      <span style={{ fontSize: 9.5, fontWeight: isActive ? 600 : 500, letterSpacing: 0.1, color: isActive ? h.ac : (h.tt || h.sc), transition: "color 0.24s", opacity: isLocked ? 0.45 : 1 }}>{l}</span>
      {isLocked && <span style={{ position: "absolute", top: 2, right: 4, fontSize: 8 }}>{"🔒"}</span>}
    </button>;
  };

  // Raised circular center Share button (landlord only). Splits the 6
  // tabs 3-left / 3-right around it. Opens the global share-properties
  // modal (pick properties -> select what to include -> share).
  const isLandlord = role === "landlord";
  const ShareButton = (
    <div style={{ flex: "0 0 auto", display: "flex", flexDirection: "column", alignItems: "center", margin: "0 2px" }}>
      <button
        onClick={() => setShareModalOpen && setShareModalOpen(true)}
        aria-label="Share properties"
        title="Share properties"
        style={{
          width: 50, height: 50, borderRadius: 25, marginTop: -26,
          background: h.gl, border: `3px solid ${h.cd}`,
          color: "#fff", cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: `0 10px 24px ${h.ac}59`,
          transition: "transform 0.18s cubic-bezier(0.32,0.72,0.22,1)",
        }}
        onPointerDown={(e) => { e.currentTarget.style.transform = "scale(0.94)"; }}
        onPointerUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
        onPointerLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
        </svg>
      </button>
      <span style={{ fontSize: 9.5, fontWeight: 600, color: h.ac, marginTop: 2 }}>{t.share || "Share"}</span>
    </div>
  );

  const half = Math.ceil(tabs.length / 2);
  const leftTabs = isLandlord ? tabs.slice(0, half) : tabs;
  const rightTabs = isLandlord ? tabs.slice(half) : [];

  // Floating pill nav (spec): detached from the edges, rounded, blurred card
  // background, soft shadow — content scrolls behind it.
  return <div style={{ position: "fixed", bottom: "max(10px, env(safe-area-inset-bottom, 10px))", left: "50%", transform: "translateX(-50%)", width: "calc(100% - 24px)", maxWidth: 406, background: h.dk ? "rgba(26,26,32,0.88)" : "rgba(255,255,255,0.9)", border: `1px solid ${h.bd}`, borderRadius: 26, backdropFilter: "saturate(180%) blur(24px)", WebkitBackdropFilter: "saturate(180%) blur(24px)", boxShadow: h.s2, display: "flex", alignItems: "center", justifyContent: "space-around", padding: "4px 6px 6px", zIndex: 50 }}>
    {leftTabs.map(renderTab)}
    {isLandlord && ShareButton}
    {rightTabs.map(renderTab)}
  </div>;
}
